import React from 'react';

import { AlertProps } from 'antd/lib/alert';

import * as Styled from './Alert.style';

export type Props = AlertProps;

export const Alert = (props: Props): JSX.Element => <Styled.Alert {...props} />;
